import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function StaticPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPage();
  }, [slug]);

  const fetchPage = async () => {
    try {
      const response = await axios.get(`${API}/pages/${slug}`);
      setPage(response.data);
    } catch (error) {
      console.error('خطأ في تحميل الصفحة:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      
      <main className="flex-grow">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl py-12 md:py-16">
          {loading ? (
            <div className="flex justify-center items-center py-20">
              <Loader2 className="h-12 w-12 animate-spin text-primary" />
            </div>
          ) : page ? (
            <div>
              <h1 className="text-4xl md:text-5xl font-bold mb-8 text-foreground">
                {page.title}
              </h1>
              <div className="prose prose-lg max-w-none text-right">
                <p className="whitespace-pre-wrap text-base leading-relaxed">{page.content}</p>
              </div>
            </div>
          ) : (
            <div className="text-center py-20">
              <p className="text-xl text-muted-foreground">الصفحة غير موجودة</p>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
}